import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { IArticleRecipe } from '@/utils/types/Article'

export default function useSeo(article: IArticleRecipe) {
  const globalStore = useGlobalStore()

  const title = `${article?.seo?.meta_title || article.subject}｜恆食堂｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = globalStore.seoDescriptions.recipeDetail.replaceAll(':name', article.subject)
  const url = article.seo?.canonical || `${import.meta.env.VITE_DOMAIN}/hence/recipe/article/${article.seo.meta_slug || article.id}`

  globalStore.setBreadcrumbs([{ title: '恆食堂', isActive: false, url: '/hence/recipe' }])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: article.seo?.og_image?.link,
    keywords: article.seo?.meta_keywords?.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '恆食堂',
            item: `${import.meta.env.VITE_DOMAIN}/hence/recipe`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: article.subject,
            item: url
          }
        ]
      },
      {
        '@type': 'Article',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': url
        },
        headline: article?.subject,
        image: article?.seo?.og_image?.link,
        publisher: {
          '@type': 'Organization',
          name: '恆隆行',
          logo: {
            '@type': 'ImageObject',
            url: 'https://testwww.hengstyle.com/_ipx/f_webp/images/default.jpg'
          }
        },
        datePublished: article?.publish_date,
        author: {
          '@type': 'Person',
          name: article?.kol_info?.name,
          url: article?.kol_info?.url
        }
      }
    ]
  })
}
